(() => {
  const TAG_PATTERN = /\[(?:colour|color)\s*:\s*([^\]]+)\]/i;

  function normalise(value = '') {
    return value
      .toString()
      .trim()
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getProductSection(element) {
    return (
      element.closest('.shopify-section') ||
      document.querySelector('.shopify-section:has(media-gallery)')
    );
  }

  function getSelectedColour(section) {
    if (!section) return '';

    /*
      Horizon circular swatches are still radio inputs.
      Try explicit option names first.
    */
    const namedInput = section.querySelector(
      [
        'input[type="radio"][name*="Colour" i]:checked',
        'input[type="radio"][name*="Color" i]:checked',
        'select[name*="Colour" i]',
        'select[name*="Color" i]'
      ].join(',')
    );

    if (namedInput) {
      return normalise(namedInput.value);
    }

    /*
      Fallback: find the option group whose legend/label says Colour or Color.
    */
    const groups = section.querySelectorAll(
      'fieldset, [class*="variant-option"], [data-option-name]'
    );

    for (const group of groups) {
      const groupName = [
        group.getAttribute('data-option-name'),
        group.querySelector('legend')?.textContent,
        group.querySelector('[class*="option-name"]')?.textContent,
        group.querySelector('[class*="variant-option__name"]')?.textContent
      ]
        .filter(Boolean)
        .join(' ');

      if (!/\bcolou?r\b/i.test(groupName)) continue;

      const checked = group.querySelector(
        'input[type="radio"]:checked, select'
      );

      if (checked) {
        return normalise(checked.value);
      }
    }

    return '';
  }

function getTaggedColour(element) {
  const image = element.matches?.('img')
    ? element
    : element.querySelector?.('img');

  if (!image) return '';

  const alt = image.getAttribute('alt') || '';
  const match = alt.match(TAG_PATTERN);

  return match ? normalise(match[1]) : '';
}

  function setVisibility(element, visible) {
    element.hidden = !visible;
    element.classList.toggle('variant-media-hidden', !visible);
    element.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  function filterGallery(section) {
    if (!section) return;

    const selectedColour = getSelectedColour(section);
    const gallery = section.querySelector('media-gallery');

    if (!selectedColour || !gallery) return;

    /*
      Main carousel slides used by Horizon.
    */
    const slides = gallery.querySelectorAll('slideshow-slide');

    slides.forEach((slide) => {
      const taggedColour = getTaggedColour(slide);

      const visible =
        !taggedColour ||
        taggedColour === 'all' ||
        taggedColour === selectedColour;

      setVisibility(slide, visible);
    });

    /*
      Desktop grid presentation.
    */
    const gridItems = gallery.querySelectorAll(
      '.media-gallery__grid > li'
    );

    gridItems.forEach((item) => {
      const taggedColour = getTaggedColour(item);

      const visible =
        !taggedColour ||
        taggedColour === 'all' ||
        taggedColour === selectedColour;

      setVisibility(item, visible);
    });

    /*
      Thumbnail buttons.
    */
    const thumbnails = gallery.querySelectorAll(
      '.slideshow-controls__thumbnail'
    );

    thumbnails.forEach((thumbnail) => {
      const taggedColour = getTaggedColour(thumbnail);

      const visible =
        !taggedColour ||
        taggedColour === 'all' ||
        taggedColour === selectedColour;

      setVisibility(thumbnail, visible);
    });

    /*
      Move to the first visible media after filtering.
    */
    requestAnimationFrame(() => {
      const firstVisibleThumbnail = Array.from(thumbnails).find(
        (thumbnail) => !thumbnail.hidden
      );

      const selectedThumbnail = gallery.querySelector(
        '.slideshow-controls__thumbnail[aria-selected="true"]'
      );

      if (
        firstVisibleThumbnail &&
        (!selectedThumbnail || selectedThumbnail.hidden)
      ) {
        firstVisibleThumbnail.click();
      } else {
        const firstVisibleSlide = Array.from(slides).find(
          (slide) => !slide.hidden
        );

        if (firstVisibleSlide) {
          firstVisibleSlide.scrollIntoView({
            block: 'nearest',
            inline: 'nearest'
          });
        }
      }
    });
  }

  function scheduleFilter(section) {
    window.clearTimeout(section._variantMediaTimer);

    section._variantMediaTimer = window.setTimeout(() => {
      filterGallery(section);
    }, 120);
  }

  function initialiseSection(section) {
    if (!section || section.dataset.colourMediaFilter === 'ready') return;

    section.dataset.colourMediaFilter = 'ready';

    /*
      Handles circular swatches, buttons and select menus.
    */
    section.addEventListener('change', (event) => {
      if (
        event.target.matches(
          'input[type="radio"], select, [name*="option" i]'
        )
      ) {
        scheduleFilter(section);
      }
    });

    section.addEventListener('click', (event) => {
      if (
        event.target.closest(
          'label, [class*="swatch"], [class*="variant-option"]'
        )
      ) {
        scheduleFilter(section);
      }
    });

    /*
      Horizon may rerender product details after variant selection.
    */
    const observer = new MutationObserver((mutations) => {
      const galleryChanged = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some(
          (node) =>
            node.nodeType === 1 &&
            (node.matches?.('media-gallery, slideshow-slide') ||
              node.querySelector?.('media-gallery, slideshow-slide'))
        )
      );

      if (galleryChanged) {
        scheduleFilter(section);
      }
    });

    observer.observe(section, {
      childList: true,
      subtree: true
    });

    scheduleFilter(section);
  }

  function initialiseAll() {
    document
      .querySelectorAll('.shopify-section:has(media-gallery)')
      .forEach(initialiseSection);
  }

  document.addEventListener('DOMContentLoaded', initialiseAll);
  document.addEventListener('shopify:section:load', initialiseAll);
})();